const fftChartObject = {
  zoomEnabled: true,
  panEnabled: true,
  animationEnabled: true,
  rangeSelector: {
    enabled: false,
    selectedRangeButtonIndex: 1,
    buttons: [{
      label: "Hourly",
      range: 1,
      rangeType: "hour"
    }, {
      label: "Daily",
      range: 1,
      rangeType: "day"
    }, {
      label: "Weekly",
      range: 1,
      rangeType: "week"
    }]
  },
  charts: [{
    axisX: {
      titleFontSize: 12,
      titleFontColor: "#444",
      titleFontFamily: "Roboto-Regular",
      interval: 0,
      labelFontFamily: "Roboto-Regular",
      labelFontColor: "#444",
      labelFontSize: 12,
      margin: 10,
      tickLength: 15,
      tickColor: "transparent",
      scaleBreaks: {
        autoCalculate: true,
        type: "wavy",
      },
      stripLines: []
    },
    axisY: {
      prefix: "",
      includeZero: false,
      gridThickness: 1,
      gridColor: "#e8e8e8",
      labelFontFamily: "Roboto-Regular",
      labelFontColor: "#444",
      labelFontSize: 12,
      lineThickness: 0,
      tickLength: 10,
      tickColor: "transparent",
    },
    toolTip: {
      shared: true,
      contentFormatter: function (e) {
        if (e.chart.options.myValue === 'Acceleration') {
          var content = "Sample Count" + " ";
        }else if(e.chart.options.myValue === "cepstrum"){
          var content = "Quefrency" + " "
        } else {
          var content = "Frequency" + " ";
        }
        for (var i = 0; i < e.entries.length; i++) {
          if (i == 0) {
            if (e.chart.options.myValue === 'Acceleration') {
              content +=
                e.entries[i].dataPoint.x.toFixed(1) +"<br/>";
            }else if(e.chart.options.myValue === "cepstrum"){
              content +=
                  e.entries[i].dataPoint.x.toFixed(6) + " Sec" + "<br/>";
            } else {
              content +=
                e.entries[i].dataPoint.x.toFixed(1) + " Hz" + "<br/>";
            }
          }
          if (e.chart.options.myValue === "fft" || e.chart.options.myValue === 'Acceleration') {
            content +=
              e.entries[i].dataSeries.name +
              " " +
              "<strong>" +
              e.entries[i].dataPoint.y.toFixed(2) +
              " " +
              "m/sec<sup>2</sup>" +
              "</strong>";
          } else if (e.chart.options.myValue === "magnetic") {
            content +=
              e.entries[i].dataSeries.name +
              " " +
              "<strong>" +
              e.entries[i].dataPoint.y.toFixed(2) +
              " " +
              "Gs" +
              "</strong>";
          } else {
            content +=
              e.entries[i].dataSeries.name +
              " " +
              "<strong>" +
              e.entries[i].dataPoint.y.toFixed(2) +
              " " +
              "mm/sec" +
              "</strong>";
          }
          content += "<br/>";
        }
        return content;
      },
    },
    legend: {
      verticalAlign: "top",
      fontSize: 19,
      fontColor: "#191919",
      fontWeight: "normal",
      markerMargin: 10,
      fontFamily: "Roboto-Regular",
      cursor: "pointer",
      itemclick: function (e) {
        if (
          typeof e.dataSeries.visible === "undefined" ||
          e.dataSeries.visible
        ) {
          e.dataSeries.visible = false;
        } else {
          e.dataSeries.visible = true;
        }
        e.chart.render();
      },
    },
    data: [],
  }],
  navigator: {
    dynamicUpdate: false,
    data: [
      {
        type: "line",
        dataPoints: []
      },
      {
        type: "line",
        dataPoints: []
      },
      {
        type: "line",
        dataPoints: []
      }
    ],
  }
}

module.exports = fftChartObject;
